import React from 'react'

import LeftIcon from 'reactGarden/GenericCarousel/components/LeftIcon'
import RightIcon from 'reactGarden/GenericCarousel/components/RightIcon'

import * as S from './styled'

const Navigation = ({
  prevProps,
  nextProps,
  prevArrowTrackingEvent = {},
  nextArrowTrackingEvent = {}
}) => (
  <div>
    <S.Box {...prevProps} {...prevArrowTrackingEvent}>
      <LeftIcon />
    </S.Box>
    <S.Box {...nextProps} {...nextArrowTrackingEvent}>
      <RightIcon />
    </S.Box>
  </div>
)

export default Navigation
